/**
 * Created by Rumyantsev Daniil on 02.08.2018.
 */

export class MetersValuesModel {

  isTodayLate;
  valueLimits;
  metersValues;
  realtyExternalId;
  currBillingPeriod;
  prevBillingPeriod;
  nextBillingPeriod;
  userBillingPeriod;
  prevPrevBillingPeriod;
  isNowCalculatingPeriod;
  dayPeriodEndForCurrMonth;
  dayPeriodEndForCurrBillingPeriod;
  meterValueLimitSetting;
  orgName;

  constructor(data: any) {
    this.isTodayLate = data.late;
    this.metersValues = data.meterValueList;
    this.realtyExternalId = data.realtyExternalId;
    this.valueLimits = data.meterValueLimitSetting;
    this.prevBillingPeriod = data.prevBillingPeriod;
    this.nextBillingPeriod = data.nextBillingPeriod;
    this.userBillingPeriod = data.userBillingPeriod;
    this.currBillingPeriod = data.currentBillingPeriod;
    this.prevPrevBillingPeriod = data.prevPrevBillingPeriod;
    this.meterValueLimitSetting = data.meterValueLimitSetting;
    this.isNowCalculatingPeriod = data.isNowCalculatingPeriod;
    this.dayPeriodEndForCurrMonth = data.dayPeriodEndForCurrMonth;
    this.dayPeriodEndForCurrBillingPeriod = data.dayPeriodEndForCurrBillingPeriod;
    this.orgName = data.orgName;
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/send-values-widget/meters-values-model.ts